import { createSlice } from "@reduxjs/toolkit";

const initialState = { userToken: null };

const userTokenSlice = createSlice({
  name: "userToken",
  initialState,
  reducers: {
    setUserToken: (state, action) => {
      state.userToken = action.payload;
    },

    removeUserToken: () => initialState,
  },
});

export const { setUserToken, removeUserToken } = userTokenSlice.actions;

export default userTokenSlice.reducer;
